import CourseHero from './components/CourseHero';
import CourseStructure from './components/CourseStructure';
import ModuleBreakdown from './components/ModuleBreakdown';
import LearningOutcomes from './components/LearningOutcomes';
import CourseFeatures from './components/CourseFeatures';
import CourseCTA from './components/CourseCTA';
import StickyTableOfContents from './components/StickyTableOfContents';
import StickyCourseCTA from './components/StickyCourseCTA';
import Footer from '../home/components/Footer';
import BackToTop from '../home/components/BackToTop';

export default function CourseOverviewPage() {
  return (
    <div className="min-h-screen bg-white">
      <CourseHero />
      <StickyTableOfContents />
      <CourseStructure />
      <ModuleBreakdown />
      <LearningOutcomes />
      <CourseFeatures />
      <CourseCTA />
      <Footer />
      <BackToTop />
      <StickyCourseCTA />
    </div>
  );
}